import { combineReducers } from "redux";

// Admin
import authReducers from "./authReducer";
import alertReducers from "./alertReducer";
import adminReducers from "./adminReducer";

// Leads
import leadsReducer from "./allleadsReducer";
import olaLeadsReducer from "./olaleadsReducer";
import ampereLeadsReducer from "../reducers/ampereReducer";
import brandCombinationReducer from "./brandCombinationReducer";

// Columns
import columnsReducer from "../slices/columnsSlice";
import olaColumnsReducer from "../slices/olaColumnsSlice";
import ampereColumnsReducer from "../slices/ampereColumnSlice";
import subAdminReducers from "./subAdminReducer";
import brandCombinationColumnReducer from "../slices/brandCombinationColumnSlice";
import sourceCombinationReducer from "../reducers/sourceCombinationReducer";
import subSourceCombinationReducer from "../reducers/subSourceCombinationReducer";
import sourceColumnCombinationReducer from "../slices/sourceCombinationColumnSlice";
import subSourceColumnCombinationReducer from "../slices/subSourceCombinationColumnSlice";
import preferenceReducer from "../slices/preferenceSlice";
import oemHistoryReducer from "../reducers/oemHistoryReducer";
import dialShreeReducer from "../reducers/dialShreeReducer";
import dialShreeInbountReducer from "../reducers/dialShreeInboundReducer";
import dashboardReducer from "../slices/dashboard";
import campaignReducer from "../slices/campaignSlice";
import leadPartnerReducer from "../slices/costPerLeadSlice";
import notificationsReducer from "../slices/notificationsSlice";

export default combineReducers({
  auth: authReducers,
  alert: alertReducers,
  admin: adminReducers,
  subadmin: subAdminReducers,

  // Leads
  leads: leadsReducer,
  olaLeads: olaLeadsReducer,
  ampereLeads: ampereLeadsReducer,
  brandCombination: brandCombinationReducer,
  sourceCombination: sourceCombinationReducer,
  subSourceCombination: subSourceCombinationReducer,

  // ALl Columns
  columns: columnsReducer,
  olaColumns: olaColumnsReducer,
  ampereColumns: ampereColumnsReducer,
  brandCombinationColumns: brandCombinationColumnReducer,
  sourceColumnCombination: sourceColumnCombinationReducer,
  subSourceColumnCombination: subSourceColumnCombinationReducer,

  // Preferences
  preferences: preferenceReducer,

  // OEM History
  history: oemHistoryReducer,

  // DialShree Leads
  dialShreeLeads: dialShreeReducer,
  dialShreeInboundLeads: dialShreeInbountReducer,

  // Dasboard
  dashboardCounts: dashboardReducer,

  // Campaigns
  campaigns: campaignReducer,

  // Lead Partners (OEMs)
  leadPartners: leadPartnerReducer,
  // Notifications
  notifications: notificationsReducer,
});
